var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingspinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6373_44674)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6373_44674)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6373_44674)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 90,
    height: 90,
    rx: 45,
    fill: "#FACD33",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3398 39.5586C73.7305 40.4375 73.4375 41.3164 72.7539 42L68.5547 45.8086C68.6523 46.5898 68.6523 47.4688 68.6523 48.25C68.6523 49.1289 68.6523 50.0078 68.5547 50.7891L72.7539 54.5977C73.4375 55.1836 73.7305 56.1602 73.3398 57.0391C72.9492 58.2109 72.4609 59.2852 71.875 60.3594L71.3867 61.1406C70.7031 62.2148 70.0195 63.2891 69.2383 64.168C68.6523 64.9492 67.6758 65.1445 66.7969 64.8516L61.4258 63.1914C60.0586 64.168 58.5938 64.9492 57.1289 65.6328L55.8594 71.1992C55.6641 72.0781 54.9805 72.7617 54.1016 72.957C52.7344 73.1523 51.3672 73.25 49.9023 73.25C48.5352 73.25 47.168 73.1523 45.8008 72.957C44.9219 72.7617 44.2383 72.0781 44.043 71.1992L42.7734 65.6328C41.2109 64.9492 39.8438 64.168 38.4766 63.1914L33.1055 64.8516C32.2266 65.1445 31.25 64.9492 30.6641 64.2656C29.8828 63.2891 29.1992 62.2148 28.5156 61.1406L28.0273 60.3594C27.4414 59.2852 26.9531 58.2109 26.5625 57.0391C26.1719 56.1602 26.4648 55.2812 27.1484 54.5977L31.3477 50.7891C31.25 50.0078 31.25 49.1289 31.25 48.25C31.25 47.4688 31.25 46.5898 31.3477 45.8086L27.1484 42C26.4648 41.3164 26.1719 40.4375 26.5625 39.5586C26.9531 38.3867 27.4414 37.3125 28.0273 36.2383L28.5156 35.457C29.1992 34.3828 29.8828 33.3086 30.6641 32.332C31.25 31.6484 32.2266 31.4531 33.1055 31.7461L38.4766 33.4062C39.8438 32.4297 41.3086 31.5508 42.7734 30.9648L44.043 25.3984C44.2383 24.5195 44.9219 23.8359 45.8008 23.6406C47.168 23.4453 48.5352 23.25 50 23.25C51.3672 23.25 52.7344 23.4453 54.1016 23.6406C54.9805 23.7383 55.6641 24.5195 55.8594 25.3984L57.1289 30.9648C58.6914 31.5508 60.0586 32.4297 61.4258 33.4062L66.7969 31.7461C67.6758 31.4531 68.6523 31.6484 69.2383 32.332C70.0195 33.3086 70.7031 34.3828 71.3867 35.457L71.875 36.2383C72.4609 37.3125 72.9492 38.3867 73.4375 39.5586H73.3398ZM50 56.0625C52.7344 56.0625 55.2734 54.5977 56.7383 52.1562C58.1055 49.8125 58.1055 46.7852 56.7383 44.3438C55.2734 42 52.7344 40.4375 50 40.4375C47.168 40.4375 44.6289 42 43.1641 44.3438C41.7969 46.7852 41.7969 49.8125 43.1641 52.1562C44.6289 54.5977 47.168 56.0625 50 56.0625Z",
    fill: "#502714"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6373_44674",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6373_44674"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6373_44674",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6373_44674",
    x: -3,
    y: -2,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6373_44674"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6373_44674",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6373_44674"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 3,
    width: 90,
    height: 90,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingspinner);
export default ForwardRef;